import RecordingSocket from './Socket'
import RecordingAwareness from './Awareness'

class RecordingSocketProvider {
  constructor(url, id, doc) {
    this.url = url
    this.id = id
    this.doc = doc

    this.ws = new RecordingSocket(url)
    this.awareness = new RecordingAwareness(this.doc)
  }

  on() {}

  disconnect() {}

  destroy() {
    this.awareness.destroy()
  }
}

export default RecordingSocketProvider
